import api from '@/services/api'

export default {
  state: {
    isLoggedUserInEthosNextGen: !!localStorage.getItem('tokenUserEthosNextGen'),
    userEthosNextGen: {
      id: '',
      name: '',
    },
  },

  mutations: {
    AUTH(state, user) {
      state.isLoggedUserInEthosNextGen = true
      state.userEthosNextGen = {
        id: user.id,
        name: user.name,
      }
    },

    LOGOUT(state) {
      state.isLoggedUserInEthosNextGen = false
      state.userEthosNextGen = {
        id: '',
        name: '',
      }
    },
  },

  actions: {
    async auth({ commit }, credentials) {
      try {
        const response = await api.post('/auth', credentials)

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          id: data && data.user ? data.user.id : 0,
          name: data && data.user ? data.user.name : '',
        }

        localStorage.setItem('tokenUserEthosNextGen', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    async register({ commit }, playload) {
      try {
        const response = await api.post('/register', playload)

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          id: data && data.user ? data.user.id : 0,
          name: data && data.user ? data.user.name : '',
        }

        localStorage.setItem('tokenUserEthosNextGen', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    logout: ({ commit }) => {
      localStorage.removeItem('tokenUserEthosNextGen')
      commit('LOGOUT')
    },
  },

  getters: {
    isLoggedUserInEthosNextGen: (state) => state.isLoggedUserInEthosNextGen,
    user: (state) => state.userEthosNextGen,
  },
}
